import Vue from 'vue'
import 'chosen-js'
import 'chosen-js/chosen.css'
import './selectpicker.scss'

Vue.directive('selectpicker', {
  bind: function (el, binding, vnode) {
    console.log('binding', binding)
    console.log(123)
    var $el = $(el)
    var options = $.extend(true, {}, {
      disable_search: true,
      scroll_to_highlighted: false
    }, binding.value)

    Vue.nextTick(function () {
      console.log(456)
      $el.chosen(options).change(function (e) {
        vnode.data.on.change(e, $(el).val())
      })

      Vue.nextTick(function () {
        let $container = $el.next('.chosen-container')
        console.log('container', $container)
        $container.addClass('selectpicker')
        console.log(binding.value.height)
        if (binding.value.height) {
          $container.find('.chosen-single').css('height', binding.value.height)
          $container.find('.chosen-single').css('line-height', binding.value.height)

          $el.on('chosen:showing_dropdown', function () {
            let height = $container.find('.chosen-single').height() - 2
            $container.find('.active-result').css('height', height + 'px')
            $container.find('.active-result').css('line-height', height + 'px')
          })
        }
      })
    })
  },
  update: function (el) {
    Vue.nextTick(function () {
      $(el).trigger('chosen:updated')
    })
  },
  unbind: function (el) {
    $(el).chosen('destroy')
  }
})



// WEBPACK FOOTER //
// ./src/directives/selectpicker/index.js